function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useQuery } from '@tanstack/react-query';
import { canManageConfigKey, getCanManageAppConfig } from '@ui/guards/application';
import { useCurrentUser } from './current-user';
function canManageAppQuery(param) {
    let { organization, project, application, user } = param;
    var _ref, _ref1, _ref2;
    return {
        queryKey: [
            canManageConfigKey,
            (_ref = organization === null || organization === void 0 ? void 0 : organization.id) !== null && _ref !== void 0 ? _ref : '',
            (_ref1 = organization === null || organization === void 0 ? void 0 : organization.name) !== null && _ref1 !== void 0 ? _ref1 : '',
            project !== null && project !== void 0 ? project : '',
            application !== null && application !== void 0 ? application : '',
            (_ref2 = user === null || user === void 0 ? void 0 : user.id) !== null && _ref2 !== void 0 ? _ref2 : ''
        ],
        queryFn: ()=>{
            if (!organization || !project || !application || !user) {
                return Promise.resolve({
                    updateApplication: false,
                    updateApplicationName: false,
                    updateApplicationSettings: false,
                    deleteApplication: false
                });
            }
            return getCanManageAppConfig(organization, user, {
                id: application,
                projectId: project
            });
        }
    };
}
export function useUserCanManageApp(params) {
    const { user } = useCurrentUser();
    const { isLoading, data: can, error } = useQuery(canManageAppQuery(_object_spread_props(_object_spread({}, params), {
        user
    })));
    return {
        can,
        isLoading,
        error
    };
}
